import { compose, withProps } from "recompose";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import update from "immutability-helper";
import * as actions from "./actions";
import { createHocBase } from "app/utils";

const selectTopics = (state, props) => {
  const topics = state.topics;
  const topic = topics.topicsById[props.topicId];
  return {
    topics,
    topic
  };
};

const topicActions = dispatch => bindActionCreators(actions, dispatch);

const fetchConditional = ({
  topic,
  topicId,
  fetchTopicProposals,
  fetchTopic
}) => {
  if (!topicId) return;
  if (topic) {
    fetchTopicProposals({ topicId });
  } else {
    fetchTopic({ topicId });
  }
};

export const fetchTopic = Component =>
  class extends createHocBase(Component) {
    componentDidMount() {
      fetchConditional(this.props);
    }
    componentDidUpdate({ topicId }) {
      if (topicId === this.props.topicId) return;
      fetchConditional(this.props);
    }
  };

export const fetchTopics = Component =>
  class extends createHocBase(Component) {
    componentDidMount() {
      this.props.fetchTopics();
    }
  };

export const connectTopicState = connect(selectTopics);

export const connectTopicActions = connect(
  null,
  topicActions
);

export const withTopics = compose(
  connectTopicState,
  connectTopicActions
);

const normalizeObjectsConfig = config => {
  return update(config, {
    inputs: { $set: config.inputs || [] }
  });
};

export const withObjectsConfig = compose(
  connect(props => {
    const {
      topics: { topicsById }
    } = props;
    return {
      topicsById
    };
  }),
  withProps(props => {
    const { topicsById, topicId } = props;
    const objects = [];
    const config = {};
    for (let obj of topicsById[topicId].config.objects) {
      obj = normalizeObjectsConfig(obj);
      config[obj.type] = obj;
      objects.push(obj);
    }
    return {
      objectsConfigList: objects,
      objectsConfig: config
    };
  })
);



// WEBPACK FOOTER //
// ./src/app/topics/hocs.js